module.exports = __webpack_public_path__ + "static/guepe-2029befc7dc01f7fdaabcf696bc6bb3e.gif";